module.exports = "<input #input (change)=\"onChanged($event)\" (keydown)=\"onKeyDown($event)\" [(ngModel)]=\"txt\" />"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Grid/textEditor.component.html
// module id = 488
// module chunks = 1